// extracted by css-extract-rspack-plugin
var _1 = "Ue3jpjWnfJ8S1PEQ";
var _2 = "Htyl7BbRmnM1AAWc";
var _3 = "YHtZTP2gIZ4AewY2";
var _4 = "X04U_qYPlgQ3ld0x";
var _5 = "kZ5PogOp0xUvgGQg";
var _6 = "PlMVvRzEKMUX1P7Z";
var _7 = "zN2fPtBpNAYkrXXM";
var _8 = "zN2fPtBpNAYkrXXM";
var _9 = "J2FuInW42oY04OBi";
var _a = "l_j3mVov9XMKrvF5";
var _b = "vF4YLqBLpikYgY3x";
var _c = "wxbcAnqJDpchxGsJ";
var _d = "l_j3mVov9XMKrvF5";
var _e = "FlsR0vi8614LBvUI";
var _f = "vF4YLqBLpikYgY3x";
var _10 = "wxbcAnqJDpchxGsJ";
var _11 = "FlsR0vi8614LBvUI";
var _12 = "pgMyI1Sq2k4zq9Lf";
var _13 = "jLt6x5FdrPs37TIa";
var _14 = "INC9_hL_zkZ7L27n";
var _15 = "INC9_hL_zkZ7L27n";
export { _1 as "container", _2 as "extended", _3 as "goals", _4 as "label", _5 as "link", _6 as "score", _7 as "score--big", _8 as "scoreBig", _9 as "stats", _a as "stats--big", _b as "statsA", _c as "statsB", _d as "statsBig", _e as "statsDraw", _f as "stats__a", _10 as "stats__b", _11 as "stats__draw", _12 as "subtitle", _13 as "title", _14 as "vs-team", _15 as "vsTeam" }
